import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { PAGES } from '../../constants/pages';
import {
  ACCOUNT_TYPE_IRA_ROTH,
  ACCOUNT_TYPE_IRA_TRADITIONAL,
  APPLICATION_TYPE_IRA,
} from '../../constants/accountTypes';
import useChooseApplication from '../../hooks/useChooseApplication';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import SelectList from '../../components/SelectList/SelectList';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import SaveAndCloseModal from '../../components/Modals/SaveAndCloseModal/SaveAndCloseModal';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { ACCOUNT_TYPE_GTM } from '../../constants/sessionStorage';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';

const ChooseApplicationRetirementPersonal = () => {
  const { t } = useTranslation();
  const { onSelectType } = useChooseApplication();
  const { BrokerName } = useSelector(selectSettings);
  const [eventType, setEventType] = useState('NoForm');
  const [saveAndCloseModalOpen, setSaveAndCloseModalOpen] = useState(false);
  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  const gtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Choose Application Retirement Personal',
      accountType: accountGtmType,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'Secure Your Account',
      accountType: accountGtmType,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
  };

  const options = [
    {
      title: t(
        'selectPath.options.retirement.owner.personalType.traditional.title',
      ),
      list: [
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.traditional.taxDefer',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.traditional.easyFund',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.traditional.usOnly',
          ),
          fontWeight: 600,
        },
      ],
      onClick: () => {
        onSelectType({
          ApplicationType: APPLICATION_TYPE_IRA,
          IRAAccountType: ACCOUNT_TYPE_IRA_TRADITIONAL,
        });
        gtmEvent();
      },
    },
    {
      title: t('selectPath.options.retirement.owner.personalType.roth.title'),
      list: [
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.roth.taxFree',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.roth.easyFund',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.roth.usOnly',
          ),
          fontWeight: 600,
        },
      ],
      onClick: () => {
        onSelectType({
          ApplicationType: APPLICATION_TYPE_IRA,
          IRAAccountType: ACCOUNT_TYPE_IRA_ROTH,
        });
        gtmEvent();
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      previousPath={PAGES.CHOOSE_APPLICATION.RETIREMENT.MAIN}
      canShowEmail={false}
      setEventType={setEventType}
      eventType={eventType}
      setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
    >
      <Helmet>
        <title>
          {t('selectPath.options.retirement.owner.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>
        {t('selectPath.options.retirement.owner.titlePersonal')}
      </Heading>
      <SelectList options={options} />
      {saveAndCloseModalOpen && (
        <SaveAndCloseModal
          isOpen={saveAndCloseModalOpen}
          onClose={() => setSaveAndCloseModalOpen(false)}
        />
      )}
    </BaseLayout>
  );
};

export default ChooseApplicationRetirementPersonal;
